export default __webpack_public_path__ + "static/media/emirates.2481f6c1.png";